"use client";

import Link from "next/link";
import { Search as SearchIcon, PackageOpen } from "lucide-react";

export function GridSkeleton({ count = 12 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 items-stretch">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex flex-col h-full rounded-xl border bg-card overflow-hidden">
          <div className="aspect-square w-full bg-muted animate-pulse" />
          <div className="p-3 flex-1 flex flex-col gap-1.5">
            <div className="h-3 bg-muted animate-pulse rounded w-2/3" />
            <div className="h-3 bg-muted animate-pulse rounded" />
            <div className="h-3 bg-muted animate-pulse rounded w-5/6 min-h-[2.2em]" />
            <div className="mt-auto pt-1 space-y-1">
              <div className="h-2.5 bg-muted animate-pulse rounded w-1/4" />
              <div className="h-5 bg-muted animate-pulse rounded w-1/2" />
              <div className="h-2.5 bg-muted animate-pulse rounded w-1/3" />
            </div>
            <div className="h-2.5 bg-muted animate-pulse rounded w-2/3" />
          </div>
          <div className="px-3 pb-3 flex gap-2">
            <div className="h-8 flex-1 bg-muted animate-pulse rounded" />
            <div className="h-8 w-8 bg-muted animate-pulse rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function EmptyState({
  query,
  onClearAll,
  hasFilters,
}: {
  query?: string;
  onClearAll?: () => void;
  hasFilters?: boolean;
}) {
  return (
    <div className="rounded-2xl border border-dashed bg-card/40 p-10 text-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
        {query ? (
          <SearchIcon className="w-5 h-5 text-muted-foreground" />
        ) : (
          <PackageOpen className="w-5 h-5 text-muted-foreground" />
        )}
      </div>
      <h3 className="text-base font-bold mb-1">
        {query ? `Sin resultados para "${query}"` : "Sin productos por ahora"}
      </h3>
      <p className="text-xs text-muted-foreground max-w-sm mx-auto mb-5">
        {hasFilters
          ? "Prueba a limpiar los filtros o cambiar tu búsqueda. También puedes explorar otras categorías."
          : "Aún no hay productos para mostrar con estos criterios."}
      </p>
      <div className="flex items-center justify-center gap-2">
        {hasFilters && onClearAll && (
          <button
            type="button"
            onClick={onClearAll}
            className="inline-flex items-center h-9 px-4 rounded-full border bg-card hover:bg-muted text-xs font-semibold"
          >
            Limpiar filtros
          </button>
        )}
        <Link
          href="/comparador"
          className="inline-flex items-center h-9 px-4 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 text-xs font-bold"
        >
          Ver todos los productos
        </Link>
      </div>
    </div>
  );
}
